import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TableKeyboardNavigationService } from './table-keyboard-navigation.service';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [],
    declarations: [],
    providers: [
        TableKeyboardNavigationService,
    ],
})
export class TableKeyboardNavigationModule { }